import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Button, Breadcrumbs, Link } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/**
 * Header for Customer Invoices page: breadcrumbs + Back button.
 * Reusable for consistent layout.
 */
const CustomerInvoicesHeader = ({ customerName, billingManagementPath = "/billing-management" }) => {
  const history = useHistory();

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 1 }}>
      <Breadcrumbs sx={{ fontSize: "0.875rem", "& .MuiBreadcrumbs-separator": { color: "#94a3b8", mx: 0.5 } }}>
        <Link
          component="button"
          variant="body2"
          onClick={() => history.push(billingManagementPath)}
          sx={{ color: "#64748b", textDecoration: "none", cursor: "pointer", fontSize: "0.875rem", "&:hover": { color: "#0f172a" } }}
        >
          Billing & Invoicing
        </Link>
        <Typography variant="body2" sx={{ color: "#3b82f6", fontSize: "0.875rem", fontWeight: 600, px: 0.5 }}>
          Invoices{customerName ? ` (${customerName})` : ""}
        </Typography>
      </Breadcrumbs>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => history.push(billingManagementPath)}
        sx={{ textTransform: "none", color: "#64748b", "&:hover": { bgcolor: "rgba(0,0,0,0.04)" } }}
      >
        Back
      </Button>
    </Box>
  );
};

export default CustomerInvoicesHeader;
